import React, {useState, useEffect, useRef} from 'react';

type CommonGlobalPropsVO = {
    enums?: any,
    name?: any
    data?: any
}

const TextByName: React.FC<CommonGlobalPropsVO> = props => {
    const { enums, name, data } = props
    return (
        <>
            {
                Array.isArray(data?.[name]) ?
                    data?.[name]?.map((item: string, index: any) => {
                        return <div>{item}</div>
                    })
                    : <div>{data?.[name]}</div>
            }
        </>

    );
};

export default TextByName;
